import React, { useEffect, useState } from "react";
import * as api from "../../api/index";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const Conversations = () => {
  const navigate = useNavigate();
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({ totalPages: 1 });

  useEffect(() => {
    const fetchConvos = async () => {
      try {
        setLoading(true);
        setErrorMsg("");
        const res = await api.getConversationsadmin(page, 10); // 5 per page
        setConversations(res.data.conversations || []);
        setPagination(res.data.pagination || { totalPages: 1 });
      } catch (err) {
     
        setErrorMsg("Failed to load chats.");
      } finally {
        setLoading(false);
      }
    };
    fetchConvos();
  }, [page]);

  return (
    <div className="flex flex-col min-h-screen bg-gray-100 p-6">
      {/* Header */}
      <div className="w-full mb-4 flex justify-between items-center">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center text-gray-700 hover:text-gray-900"
        >
          <IoMdArrowBack size={24} />
          <span className="ml-1">Back</span>
        </button>
      </div>

      {/* Card Container */}
      <div className="max-w-5xl w-full mx-auto bg-white p-8 rounded-xl shadow-md">
        <h1 className="text-2xl font-bold mb-6 text-gray-800">All Chats</h1>

        {loading ? (
          <p className="text-gray-500">Loading chats...</p>
        ) : errorMsg ? (
          <p className="text-red-500">{errorMsg}</p>
        ) : conversations.length === 0 ? (
          <p className="text-gray-500">No chats yet</p>
        ) : (
          <div className="space-y-4">
            {conversations.map((c) => {
              // Show both members since this is admin
              const users = c.members.map((m) => m.Name).join(", ");
              return (
                <div
                  key={c._id}
                  className="p-4 bg-gray-50 shadow rounded-lg border border-gray-200 flex items-center justify-between cursor-pointer hover:bg-gray-100"
                  onClick={() => navigate(`/chat/${c._id}`)}
                >
                  <div className="flex items-center gap-3">
                    <div className="flex -space-x-2">
                      {c.members.map((m) => (
                        <img
                          key={m._id}
                          src={
                            m.profileImage
                              ? `${m.profileImage}`
                              : "/default.png"
                          }
                          alt={m.Name}
                          className="w-10 h-10 rounded-full object-cover border"
                        />
                      ))}
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800">{users}</p>
                      <p className="text-sm text-gray-600 truncate max-w-xs">
                        {c.lastMessage
                          ? c.lastMessage.text || "[file]"
                          : "No messages yet"}
                      </p>
                    </div>
                  </div>

                  <div className="flex flex-col items-end">
                    <span className="text-xs text-gray-500">
                      {c.lastMessage?.createdAt
                        ? new Date(c.lastMessage.createdAt).toLocaleString()
                        : ""}
                    </span>
                    {c.unreadCount > 0 && (
                      <span className="mt-1 bg-red-500 text-white text-xs px-2 py-0.5 rounded-full">
                        {c.unreadCount}
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Pagination Controls */}
        <div className="mt-6 flex justify-center gap-3">
          <button
            disabled={page <= 1}
            onClick={() => setPage((p) => p - 1)}
            className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
          >
            Prev
          </button>
          <span className="px-2 text-gray-700">
            Page {page} of {pagination.totalPages}
          </span>
          <button
            disabled={page >= pagination.totalPages}
            onClick={() => setPage((p) => p + 1)}
            className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Conversations;
